// API 에러 처리 유틸리티

export const handleLoginError = (error) => {
  if (error.response) {
    const errorDetail = error.response.data?.detail || error.code;

    if (errorDetail === 'User is not approved.') {
      return {
        success: false,
        error: {
          code: 401,
          message: 'waiting_approval'
        }
      };
    }

    if (errorDetail === 'User is blocked.') {
      return {
        success: false,
        error: {
          code: 401,
          message: 'blocked'
        }
      };
    }

    if (errorDetail === 'Invalid password.') {
      return {
        success: false,
        error: {
          code: 401,
          message: 'Invalid password'
        }
      };
    }

    const errorDetailLower = errorDetail.toLowerCase();

    if (errorDetailLower.includes('not approved') ||
      errorDetailLower.includes('approval required') ||
      errorDetailLower.includes('waiting for admin') ||
      errorDetailLower.includes('need approval')) {
      return {
        success: false,
        error: {
          code: 401,
          message: 'waiting_approval'
        }
      };
    }

    if (errorDetailLower.includes('blocked') ||
      errorDetailLower.includes('banned') ||
      errorDetailLower.includes('suspended')) {
      return {
        success: false,
        error: {
          code: 401,
          message: 'blocked'
        }
      };
    }

    if (errorDetailLower.includes('not found') ||
      errorDetailLower.includes('not exist') ||
      errorDetailLower.includes('does not exist') ||
      errorDetailLower.includes('no user') ||
      errorDetailLower.includes('user not found')) {
      return {
        success: false,
        error: {
          code: 404,
          message: 'Account does not exist'
        }
      };
    }

    if (errorDetailLower.includes('invalid password') ||
      errorDetailLower.includes('incorrect password') ||
      errorDetailLower.includes('wrong password')) {
      return {
        success: false,
        error: {
          code: 401,
          message: 'Invalid password'
        }
      };
    }
  }

  if (error.code) {
    return {
      success: false,
      error: error
    };
  }

  return {
    success: false,
    error: {
      code: error.response?.status || 500,
      message: error.response?.status === 0 ? 'network' : 'unknown'
    }
  };
};

// 에러 detail을 문자열로 변환하는 헬퍼 함수
const formatErrorDetail = (detail) => {
  if (!detail) {
    return null;
  }
  
  // 배열인 경우 (FastAPI validation error)
  if (Array.isArray(detail)) {
    return detail.map(item => {
      if (typeof item === 'object' && item !== null) {
        return item.msg || item.message || JSON.stringify(item);
      }
      return String(item);
    }).join(', ');
  }
  
  // 문자열인 경우
  if (typeof detail === 'string') {
    return detail;
  }
  
  // 객체인 경우
  if (typeof detail === 'object' && detail !== null) {
    return detail.msg || detail.message || JSON.stringify(detail);
  }
  
  // 기타 타입
  return String(detail);
};

export const handleApiError = (error, defaultMessage = 'API 요청 중 오류가 발생했습니다.') => {
  console.error('API Error:', error);
  
  if (error.response) {
    const { status, data } = error.response;
    
    switch (status) {
      case 400:
        return {
          success: false,
          error: {
            code: status,
            message: formatErrorDetail(data?.detail) || '잘못된 요청입니다.',
            data: data
          },
          data: data
        };
      case 401:
        return {
          success: false,
          error: {
            code: status,
            message: '인증이 필요합니다.',
            data: data
          },
          data: data
        };
      case 403:
        return {
          success: false,
          error: {
            code: status,
            message: '접근 권한이 없습니다.',
            data: data
          },
          data: data
        };
      case 404:
        return {
          success: false,
          error: {
            code: status,
            message: '요청한 리소스를 찾을 수 없습니다.',
            data: data
          },
          data: data
        };
      case 422:
        return {
          success: false,
          error: {
            code: status,
            message: formatErrorDetail(data?.detail) || '요청 데이터가 유효하지 않습니다.',
            data: data
          },
          data: data
        };
      case 500:
        return {
          success: false,
          error: {
            code: status,
            message: '서버 오류가 발생했습니다.',
            data: data
          },
          data: data
        };
      default:
        return {
          success: false,
          error: {
            code: status,
            message: formatErrorDetail(data?.detail) || defaultMessage,
            data: data
          },
          data: data
        };
    }
  }

  return {
    success: false,
    error: {
      code: 0,
      message: '네트워크 오류가 발생했습니다.'
    }
  };
};

export const isDuplicateError = (error) => {
  return error.response?.status === 400 && 
         error.response?.data?.detail?.toLowerCase().includes('already exists');
};

export const isValidationError = (error) => {
  return error.response?.status === 400 && 
         error.response?.data?.detail?.toLowerCase().includes('validation');
}; 